import React, {useEffect} from 'react';
import { motion } from 'framer-motion';

import Header from '../components/Header';
import ProjectsGrid from '../components/Project/ProjectsGrid';
import About from "../components/About";
import ContactForm from "../components/ContactForm";
import PageMeta from '../components/PageMeta';

import Image from '../assets/projects.webp';
import Specifications from '../components/Specifications/Specifications';
import People from '../components/People/PeopleList.json';

const Home = () => {
    useEffect(() => {
        document.title = "Nick Nettleton";
    });
    
    return (
        <motion.div
            initial={{ translateY: -50, scale: 1, opacity: 0 }}
            animate={{ translateY: 0, opacity: 1 }}
            exit={{ translateX: -50, opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96] }}>
            <PageMeta description="Software Engineer specializing in web applications, mobile apps, and business systems." handle={`/`} />
            <Header
                title="Nick Nettleton"
                tagline={ <><span className='underline'>Software Engineer</span> specializing in web applications, mobile apps, and business systems.</> } 
                image={Image}
                subtitle="ATLANTA, GEORGIA"
                id="home" />
            <section>
                <div className="container">
                    <p className="section-title">My Experience</p>
                    <Specifications dataset={People[0].stats} cols={4} />
                </div>
            </section>
            <ProjectsGrid />
            <About />
            <ContactForm />
        </motion.div>
    );
};

export default Home;